import { useEffect } from "react";

/**
 * Sets document.title, <meta name="description">, canonical link and
 * Open Graph tags per-page. Improves SEO because Google indexes the
 * final rendered <head> after JS execution.
 */
export default function usePageMeta({
  title,
  description,
  path = "",
  keywords,
} = {}) {
  useEffect(() => {
    if (!title) return;
    const prevTitle = document.title;
    document.title = title;

    const upsertMeta = (attr, key, value) => {
      if (!value) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };

    upsertMeta("name", "description", description);
    upsertMeta("name", "keywords", keywords);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    if (typeof window !== "undefined") {
      const url = window.location.origin + (path || window.location.pathname);
      upsertMeta("property", "og:url", url);

      // Canonical
      let canonical = document.head.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", url);
    }

    return () => {
      document.title = prevTitle;
    };
  }, [title, description, path, keywords]);
}
